/* eslint-disable radix */
import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import ReactHookSelect from 'react-hook-select';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { ReactComponent as OutreachLogo } from 'Assets/svg/export_icons/outreach.svg';
import { ReactComponent as DropDownIcon } from 'Assets/svg/dropdown-icon.svg';
import { ReactComponent as SearchIcon } from 'Assets/svg/open-search.svg';
import CRMExportHeader from './crmExportComponents';
import CancelSaveButton from '../CancelSaveButton';
import Input from '../newInputField';

class OutreachSequenceState {
  @observable showPopup = false;

  defaultPopupValue = {
    sequenceList: [],
    mailBoxList: [],
    callback() {
      console.log('callback');
    },
  };

  @observable popupValues = this.defaultPopupValue;

  @action
  setShowPopup = val => {
    this.showPopup = val;
    if (val === false) this.popupValues = this.defaultPopupValue;
  };

  @action
  setPopupValues = val => {
    this.popupValues = { ...this.popupValues, ...val };
  };
}
const outreachSequenceState = new OutreachSequenceState();

const renderDropDownIcon = ({ isDropDownOpen }) => {
  return <DropDownIcon className={isDropDownOpen ? 'open' : ''} />;
};

const OutreachSequencePopup = observer(props => {
  const [selectedSeq, setSelectedSeq] = React.useState('');

  const [showSelectSequenceErr, setShowSelectSequenceErr] = React.useState(
    false,
  );

  const [selectedMailBox, setSelectedMailBox] = React.useState('');

  const [showSelectMailBoxErr, setShowSelectMailBoxErr] = React.useState(false);

  const dateObj = new Date();
  const currentMonth =
    dateObj.getMonth() + 1 < 10
      ? `0${dateObj.getMonth() + 1}`
      : dateObj.getMonth() + 1;
  const tagDefaultValue = `${currentMonth}${dateObj.getDate()}${dateObj.getFullYear()}`;
  const { sequenceList,mailBoxList } = outreachSequenceState.popupValues;

  const [tagValue, setTagValue] = React.useState(tagDefaultValue);

  React.useEffect(() => {
    if (!outreachSequenceState.showPopup) {
      setTagValue(tagDefaultValue);
      setSelectedSeq('');
      setSelectedMailBox('');
    }
  }, [outreachSequenceState.showPopup]);

  const confirmClick = () => {
    if (selectedSeq !== '' && selectedMailBox !== '') {
      outreachSequenceState.popupValues.callback(
        selectedSeq,
        selectedMailBox,
        tagValue,
      );
      outreachSequenceState.setShowPopup(false);
      setTagValue('');
    } else if (selectedMailBox === '') {
      setShowSelectMailBoxErr(true);
    } else {
      setShowSelectSequenceErr(true);
    }
  };

  const skipAndContinue = () => {
    outreachSequenceState.popupValues.callback('', '', tagValue);
    outreachSequenceState.setShowPopup(false);
    setTagValue('');
  };

  const onTagChange = value => {
    setTagValue(value);
  };

  return outreachSequenceState.showPopup ? (
    <>
      <div className="export-type-popup sequence-popup common-popup">
        <div className="popup-wrap">
          <div
            className="popup-close"
            title="Click here to close"
            onClick={() => outreachSequenceState.setShowPopup(false)}
          >
            <CloseIcon />
          </div>

          <CRMExportHeader Logo={OutreachLogo} title="Export to Outreach" />
          <div className="popup-body">
            <div className="export-content-title">Target Sequence</div>
            <div className="export-sequence-wrap">
              <ReactHookSelect
                renderDropDownIcon={renderDropDownIcon}
                searchIcon={<SearchIcon className="search-icon" />}
                value={selectedSeq ? [selectedSeq] : []}
                showPlaceholderInOptions={false}
                placeholder="Select from dropdown"
                getValue={value => {
                  if (showSelectSequenceErr) setShowSelectSequenceErr(false);
                  setSelectedSeq(value[0]);
                }}
                options={
                  sequenceList?.length > 0
                    ? sequenceList?.map(data => {
                        return {
                          label: data.name,
                          value: data.id,
                        };
                      })
                    : []
                }
                selectWrapperProps={{
                  className: showSelectSequenceErr ? 'error-border' : '',
                }}
              />
              {showSelectSequenceErr && (
                <div className="error-txt">Select sequence to continue</div>
              )}
            </div>
            <div className="export-content-title">Select a Mail Box</div>
            <div className="export-sequence-wrap">
              <ReactHookSelect
                renderDropDownIcon={renderDropDownIcon}
                searchIcon={<SearchIcon className="search-icon" />}
                value={selectedMailBox ? [selectedMailBox] : []}
                showPlaceholderInOptions={false}
                placeholder="Select from dropdown"
                getValue={value => {
                  if (showSelectMailBoxErr) setShowSelectMailBoxErr(false);
                  setSelectedMailBox(value[0]);
                }}
                options={
                  mailBoxList?.length > 0
                    ? mailBoxList?.map(data => {
                        return {
                          label: data.name,
                          value: data.id,
                        };
                      })
                    : []
                }
                selectWrapperProps={{
                  className: showSelectMailBoxErr ? 'error-border' : '',
                }}
              />
              {showSelectMailBoxErr && (
                <div className="error-txt">Select mail box to continue</div>
              )}
            </div>
            <Input
              inputProps={{
                type: 'text',
                onChange: value => onTagChange(value),
                value: tagValue,
              }}
              label="Tags (multiples separated by commas)"
            />
          </div>
          <div className="footer-section">
            <div className="skip-ele" onClick={skipAndContinue}>
              Continue without adding to Sequence
            </div>
            <CancelSaveButton
              saveButtonText="Export"
              handleSave={confirmClick}
              handleCancel={() => outreachSequenceState.setShowPopup(false)}
            />
          </div>
        </div>
      </div>
      <div
        className="common-popup-mask"
        onClick={() => outreachSequenceState.setShowPopup(false)}
      />
    </>
  ) : (
    ''
  );
});

export { OutreachSequencePopup, outreachSequenceState };
export default OutreachSequencePopup;
